import React, { PropsWithChildren } from 'react';

import styles from './FormCardTitle.module.scss';

export const FormCardTitle = ({ children }: PropsWithChildren<{}>) => (
  <div className={styles.formCardTitle}>{children}</div>
);
